
import { type Survey, SurveyStatus } from '@/types';
import { Paper } from '@/ui';

import Empty from './Empty';
import Started from './Started';

import type { FC } from 'react';

interface CardProps {
  coach?: string;
  icon: string;
  id: string;
  name: string;
  survey?: Survey;
}

const Template: FC<CardProps> = ({ coach = '', icon, id, name, survey }) => {
  if (!survey || survey.status === SurveyStatus.DRAFT) {
    return (
      <Paper
        className="mt-10 flex w-full flex-col gap-8 rounded-xl border bg-white p-6"
        role="button"
        tabIndex={0}
      >
        <Empty id={id} name={name} />
      </Paper>
    );
  }

  return (
    <Paper
      className="mt-10 flex w-full flex-col gap-8 rounded-xl border bg-white p-6"
      role="button"
      tabIndex={0}
    >
      <Started
        coach={coach}
        icon={icon}
        id={id}
        name={name}
        participants={survey.responses ?? []}
        status={survey.status}
        totalResponses={survey.aggregated?.totalResponses}
      />
    </Paper>
  );
};
export default Template;
